<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<section>
  <div class="dta_title pad-lr-15 mar-top-20 col-md-3">{{'SUPPLIER CODE MAPPING PAGE' | translate}}</div>
  <form name="form" (ngSubmit)="addUser()" #f="ngForm" novalidate>
    <div class="container-fluid mar-top-20 ">
      <div class="dta_sub_title mar-top-20 col-md-3">{{'New Supplier Code Mapping' | translate}}</div>

      <div class="form-group col-md-6 padd">
        <label>{{'Select Supplier Code' | translate}}</label><br>
        <!-- <ng-multiselect-dropdown [settings]="settings" [data]="suppCodeList" name="supplierCode" [(ngModel)]="supplierCode" (onSelect)="onSingleSelect($event)"
          (onDeSelect)="onSingleDeSelect($event)"  *ngIf="suppCodeList" required>
        </ng-multiselect-dropdown> -->

        <div class="row">
          <div class="col-md-5">
            <ngx-select-dropdown style="display:block" [multiple]="false"  [config]="config"
              (change)="onSingleSelect($event)" [options]="optionsCodeList"></ngx-select-dropdown>
          </div>
        </div>

      </div>
      <div class="container-fluid mar-top-10 row">

        <div class="form-group col-md-2 mar-rgt-60 padd" *ngIf="adminAccess == 5 || adminAccess == 8 ">
          <span>{{'Select SMQuality' | translate}} </span>
          <ng-multiselect-dropdown name="smqualityCode"  [settings]="settingsquality" [data]="smqualityCodeList" [(ngModel)]="smqualityCode" (onSelect)="onItemSelect($event)"
            (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)"
            *ngIf="smqualityCodeList">
          </ng-multiselect-dropdown>
        </div>
        <div class="form-group col-md-2 mar-rgt-60 padd" *ngIf="adminAccess == 5 || adminAccess == 8 ">
          <span>{{'Select SMVS' | translate}} </span>
          <ng-multiselect-dropdown name="smvsCode"  [settings]="settingssmvs" [data]="smvsCodeList" [(ngModel)]="smvsCode" (onSelect)="onItemSelectsmvs($event)"
            (onDeSelect)="OnItemDeSelectsmvs($event)"  (onSelectAll)="onSelectAllsmvs($event)"
            (onDeSelectAll)="onDeSelectAllsmvs($event)" *ngIf="smvsCodeList">
          </ng-multiselect-dropdown>
        </div>
        <div class="form-group col-md-2 mar-rgt-60 padd" *ngIf="adminAccess == 5 || adminAccess == 9">
          <span>{{'Select Logistic' | translate}} </span>
          <ng-multiselect-dropdown name="logisticCode"  [settings]="settingslogistic" [data]="logisticCodeList" [(ngModel)]="logisticCode" (onSelect)="onItemSelectlogistic($event)"
            (onDeSelect)="OnItemDeSelectlogistic($event)" (onSelectAll)="onSelectAlllogistic($event)"
            (onDeSelectAll)="onDeSelectAlllogistic($event)" *ngIf="logisticCodeList">
          </ng-multiselect-dropdown>
        </div>
        <!-- <div class="form-group col-md-2 padd" *ngIf="adminAccess == 5 || adminAccess == 9 ">
            <span>Select Operation </span>
        <angular2-multiselect  name="operationCode" [data]="operationCodeList" [(ngModel)]="operationCode" (onSelect)="onItemSelectoperation($event)"
          (onDeSelect)="OnItemDeSelectoperation($event)" [settings]="settingsoperation" (onSelectAll)="onSelectAlloperation($event)"
          (onDeSelectAll)="onDeSelectAlloperation($event)" *ngIf="operationCodeList">
        </angular2-multiselect></div> -->
        <div class=" col-md-2 padd " style="margin-top: 2%;">
          <button [disabled]="userIDTaken" type="submit" value="Register" class="btn btn-dark">{{'Add User' |
            translate}}</button>
        </div>
      </div>


      <!--   col-md-12 -->

    </div>
    <!--container -->
  </form>
  <!---form closed-->
</section>

  <nav class="navbar navbar-light bg-light">
    <form class="form-inline" style="margin-left: 37%;">
      <input class="form-control mr-sm-2" ngModel name='searchField' #searchField='ngModel' [(ngModel)]="searchText" placeholder="Search" aria-label="Search" style="width: 20vw;">
      <button class="btn btn-dark" type="button" (click)="onSearch()">Search</button>
    </form>
  </nav>


<section class="parts_container">
  <div class="dta_sub_title pad-tb-20">{{'Existing Supplier Code Mapping' | translate}}</div>
  <div class="row">
    <div class="col-md-12">
      <table class="table table-white table-striped table-bordered">
        <thead> 
          <tr>
            <th>{{'SUPPLIERCODE' | translate}}</th>
            <th *ngIf="adminAccess == 5 || adminAccess == 8 ">{{'SM' | translate}}</th>
            <th *ngIf="adminAccess == 5 || adminAccess == 8 ">{{'SM-VS' | translate}}</th>
            <th *ngIf="adminAccess == 5 || adminAccess == 9 ">{{'LOGISTICS' | translate}}</th>
            <!-- <th *ngIf="adminAccess == 5 || adminAccess == 9 " class="text-center">Operations</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of users" class="even" (click)="editMapping(editMappingModal, item)">
            <td class="hasLink">{{ item.supplierCode}}</td>
            <td *ngIf="adminAccess == 5 || adminAccess == 8 ">
              <div *ngFor="let smqs of item.supplierManagerQs">{{ smqs.smqUserId }}</div>
            </td>
            <td *ngIf="adminAccess == 5 || adminAccess == 8 ">
              <div *ngFor="let smvs of item.supplierManagerVSs">{{smvs.smvsUserId}} </div>
            </td>
            <td *ngIf="adminAccess == 5 || adminAccess == 9 ">
              <div *ngFor="let log of item.logistics">{{ log.logisticsUserId }}</div>
            </td>
            <!-- <td *ngIf="adminAccess == 5 || adminAccess == 9 "><div *ngFor="let opr of item.operations" >{{ opr}}</div></td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
<pagination class="pagination-sm pull-right pad-top-10" [(ngModel)]="page" [totalItems]="totalItems"
      [itemsPerPage]="10" [maxSize]="3" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable($event)"
      (numPages)="numPages = $event">
    </pagination>

<ng-template #editMappingModal let-c="close" let-d="dismiss">
  <form name="form1" (ngSubmit)="updateSupplierMap()" #frm="ngForm" novalidate>
    <div class="modal-header">
      <h4 class="modal-title">Edit Supplier Code Mapping</h4>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mar-top-20">
        <div class="form-group col-md-6">
          <label><b>{{'SUPPLIERCODE' | translate}}: </b></label> {{suppDetails.supplierCode}}
        </div>
        <div class="row mar-top-10">
          <div class="form-group col-md-3 mar-rgt-60 padd" *ngIf="adminAccess == 5 || adminAccess == 8 ">
            <span>{{'Select SMQuality' | translate}}</span>
            <ng-multiselect-dropdown name="smqualityCodeUpt" [settings]="settingsquality" [data]="smqualityCodeList" [(ngModel)]="suppSMQList"
              (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)"
              (onDeSelectAll)="onDeSelectAll($event)"  *ngIf="smqualityCodeList">
            </ng-multiselect-dropdown>
          </div>
          <div class="form-group col-md-3 mar-rgt-60 padd" *ngIf="adminAccess == 5 || adminAccess == 8 ">
            <span>{{'Select SMVS' | translate}}</span>
            <ng-multiselect-dropdown name="smvsCodeUpt" [settings]="settingssmvs" [data]="smvsCodeList" [(ngModel)]="suppSMVSList" (onSelect)="onItemSelectsmvs($event)"
              (onDeSelect)="OnItemDeSelectsmvs($event)"  (onSelectAll)="onSelectAllsmvs($event)"
              (onDeSelectAll)="onDeSelectAllsmvs($event)" *ngIf="smvsCodeList">
            </ng-multiselect-dropdown>
          </div>
          <div class="form-group col-md-3 mar-rgt-60 padd" *ngIf="adminAccess == 5 || adminAccess == 9">
            <span>Select Logistic </span>
            <ng-multiselect-dropdown name="logisticCodeUpt"   [settings]="settingslogistic" [data]="logisticCodeList" [(ngModel)]="supplogList" (onSelect)="onItemSelectlogistic($event)"
              (onDeSelect)="OnItemDeSelectlogistic($event)" (onSelectAll)="onSelectAlllogistic($event)"
              (onDeSelectAll)="onDeSelectAlllogistic($event)" *ngIf="logisticCodeList">
            </ng-multiselect-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" value="Register" class="btn btn-dark">{{'Save' | translate}}</button>
    </div>
  </form>
</ng-template>